import { PeanutOffOutlineIcon } from './PeanutOffOutlineIcon';

/**
 * author: Michael Richins
 * id A3B86034-EAD9-4DE1-AF76-A11F21285DF9
 * name peanut-off-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/peanut-off-outline.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const FoodAllergyOffOutlineIcon = PeanutOffOutlineIcon;
export default FoodAllergyOffOutlineIcon